module.exports = "https://media.zlongame.com/media/pictures/cn/ro/hd/2024/drawcards/assets/img/pc/pop//no_card.png";